'use strict';
import jump from 'jump.js';

/*
Name: CTMS
*/
var rootCMTSLoaded = false;
class Cmts {
  //var classCMTSLoaded = false;
  constructor () {
    var showTOC = true;
    var CMTSLoaded = false;
    setInterval(function() {
      if (CMTSLoaded == false && document.querySelectorAll('h2.osArea').length > 0) {
        console.log('Found h2.osArea');
        CMTSLoaded = true;
      }
    }, 250);

    if (showTOC && document.querySelector('.osStudyItem')) {
      setTimeout(function() {
        let p = document.createElement('p');
        p.classList.add('cmtsToc');
        this.cmts = document.querySelectorAll('.osStudyItem');
        // Hard part: the order of these doesn't match the display order of the actual studies;
        // eg, on Vancouver, the toc is in numerical order, but not in the listing
        this.categories = document.querySelectorAll('h2.osArea');
        p.classList.add('count-' + this.categories.length);
        for (var i = 0; i < this.categories.length; i++) {
          this.categories[i].setAttribute('id', 'osArea-' + i);
          let a = document.createElement('a');
          let target = window.location.origin + window.location.pathname + '#osArea-' + i;
          a.setAttribute('href', target);
          a.textContent = this.categories[i].innerText;
          p.appendChild(a);
        }
        let container = document.querySelector('.rt-container');
        container.prepend(p);
      },500);
    }
  }
}

module.exports = Cmts;
